import { Box, Typography } from 'enova-frontend-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { LoadingIndicator } from '../../../../components/loadingIndicator';
import { ErrorBox } from '../../../../components/errorBox';

import { UnpublishedEnhetRegistrationList } from './components/unpublishedEnhetRegistrationList';
import { UnpublishedFlerboligRegistrationList } from './components/unpublishedFlerboligRegistrationList';
import { useGetUserRegistrations } from './hooks/useGetUserRegistrations';

export const UnpublishedRegistrationList = () => {
  const { t } = useTranslation();
  const { isLoading, data, error, refetch } = useGetUserRegistrations();

  if (isLoading) {
    return <LoadingIndicator text={t('expertRegistrationScreen.registrations.loading')} />;
  }

  if (error) {
    return (
      <Box my={5}>
        <ErrorBox
          titleKey="expertRegistrationScreen.registrationsInProgress.error.title"
          descriptionKey="expertRegistrationScreen.registrationsInProgress.error.description"
          onRetry={refetch}
          error={error}
        />
      </Box>
    );
  }

  return (
    <Box mt={15} display="flex" flexDirection="column" gap={5}>
      <Typography variant="h3">{t('expertRegistrationScreen.registrationsInProgress')}</Typography>
      <Box display="flex" flexDirection="column" gap={3}>
        <Typography variant="h4">{t('expertRegistrationScreen.enheter.header')}</Typography>
        <UnpublishedEnhetRegistrationList byggregistreringer={data?.enkeltregistreringer} />
      </Box>
      <Box display="flex" flexDirection="column" gap={3} mt={5}>
        <Typography variant="h4">{t('expertRegistrationScreen.flerboligbygg.header')}</Typography>
        <UnpublishedFlerboligRegistrationList flerboligbyggList={data?.flerboligregistreringer} />
      </Box>
    </Box>
  );
};
